import { render, staticRenderFns } from "./bis_table.vue?vue&type=template&id=2f4027b7"
import script from "./bis_table.vue?vue&type=script&lang=ts"
export * from "./bis_table.vue?vue&type=script&lang=ts"
import style0 from "./bis_table.vue?vue&type=style&index=0&id=2f4027b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports